import XAPPService from "app/Core/services/XAPPService";
export const GET_EMPRESAPESSOA = "[EMPRESAPESSOAFORMULARIO APP] GET PESSOA";
export const GET_EMPRESAPESSOA_FORMULARIO = "[EMPRESAPESSOAFORMULARIO APP] GET FORMULARIO";
export const GET_EMPRESAPESSOA_FORMULARIO_TEMPLATE = "[EMPRESAPESSOAFORMULARIO APP] GET FORMULARIO TEMPLATE";
export const GET_PESSOA_ATRIBUICAO_FORMULARIO = "[EMPRESAPESSOAFORMULARIO APP] GET ATRIBUICAO";
export const SET_SEARCH_TEXT = "[EMPRESAPESSOAFORMULARIO APP] SET SEARCH TEXT";
export const OPEN_NEW_EMPRESAPESSOA_FORMULARIO_DIALOG = "[EMPRESAPESSOAFORMULARIO APP] OPEN NEW FORMULARIO DIALOG";
export const CLOSE_NEW_EMPRESAPESSOA_FORMULARIO_DIALOG = "[EMPRESAPESSOAFORMULARIO APP] CLOSE NEW FORMULARIO DIALOG";
export const OPEN_EDIT_EMPRESAPESSOA_FORMULARIO_DIALOG = "[EMPRESAPESSOAFORMULARIO APP] OPEN EDIT FORMULARIO DIALOG";
export const CLOSE_EDIT_EMPRESAPESSOA_FORMULARIO_DIALOG = "[EMPRESAPESSOAFORMULARIO APP] CLOSE EDIT FORMULARIO DIALOG";
export const GET_FORMULARIO_INDEX = "[EMPRESAPESSOAFORMULARIO APP] GET INDEX TEMPLATE";
export const ERROR_FORMULARIO_INDEX = "[EMPRESAPESSOAFORMULARIO APP] ERROR INDEX TEMPLATE";
export const REMOVE_EMPRESAPESSOA_FORMULARIO = "[EMPRESAPESSOAFORMULARIO APP] REMOVE FORMULARIO";
export const ADD_EMPRESAPESSOA_FORMULARIO = "[EMPRESAPESSOAFORMULARIO APP] ADD FORMULARIO";
export const EMPRESAPESSOA_FORMULARIO_WARNING = "[EMPRESAPESSOAFORMULARIO APP] EMPRESAPESSOA_FORMULARIO WARNING";
export const EMPRESAPESSOA_FORMULARIO_INFO = "[EMPRESAPESSOAFORMULARIO APP] EMPRESAPESSOA_FORMULARIO INFO";
export const EMPRESAPESSOA_FORMULARIO_ERROR = "[EMPRESAPESSOAFORMULARIO APP] EMPRESAPESSOA_FORMULARIO ERROR";

export const EmpresaPessoaFormularioListState =
    [
        "idpessoaformulario",
        "idparent",
        "idpessoa",
        "tipo",
        "tipodescricao",
        "formulario",
        "usrins",
        "usrupt",
        "datainsdescricao",
        "datauptdescricao",
    ];

const EmpresaPessoaFormularioAddState =
    [
        "idpessoa",
        "idparent",
        "tipo",
        "formulario",
    ];

const EmpresaPessoaFormularioUpdateState =
    [
        "formulario",
    ];

export function getTemplate(_AID) {
    return (dispatch) => {

        XAPPService.XappGetTemplateAction("pessoa", _AID)
            .then((response) =>
                Promise.all([
                    dispatch({
                        type: GET_EMPRESAPESSOA_FORMULARIO_TEMPLATE,
                        payload: { ...response, id: _AID },
                    })
                ])
            )
            .catch(error => {
                return dispatch({
                    type: EMPRESAPESSOA_FORMULARIO_ERROR,
                    payload: error
                });
            });
    };
}

export function getTemplateIndex() {
    return (dispatch, getState) => {
        XAPPService.XappGetTemplateIndexAction("pessoaindex", getState().auth.user.data.settings.pathpessoa)
            .then((response) =>
                Promise.all([
                    dispatch({
                        type: GET_FORMULARIO_INDEX,
                        payload: response.templates,
                    })
                ])
            )
            .catch(error => {
                return dispatch({
                    type: EMPRESAPESSOA_FORMULARIO_ERROR,
                    payload: error
                });
            });
    };
}

export function list(_AAction, _AParams, _AID, _ATipo = "all") {

    return (dispatch) => {
        var AConditionsAND = [{ "Campo": "pessoaformulario.idparent", "Operador": "=", "Valor": _AID }];
        if (_ATipo !== "all") {
            AConditionsAND.push({ "Campo": "tipo", "Operador": "=", "Valor": _ATipo });
        }
        var AConditionsOR = [];
        var AActions = [];
        AActions = XAPPService.XappSelActionFactory(_AParams.empresa, "EmpresaPessoaFormulario", AActions, "spvwpessoaformulario", EmpresaPessoaFormularioListState, _AAction, AConditionsAND, AConditionsOR);

        AConditionsAND = [{ "Campo": "pessoaformulario.idpessoaformulario", "Operador": "=", "Valor": _AID }];
        AActions = XAPPService.XappSelActionFactory(_AParams.empresa, "EmpresaPessoa", AActions, "spvwempresapessoa", ["*"], _AAction, AConditionsAND, AConditionsOR);

        XAPPService.XappSelAction(AActions, _AParams, "SEL")
            .then((response) =>
                Promise.all([
                    dispatch({
                        type: GET_EMPRESAPESSOA_FORMULARIO,
                        Name: (response.data && response.data.length > 0) ? JSON.parse(response.data)[0].name : "",
                        payload: (response.data && response.data.length > 0) ? JSON.parse(response.data)[0].data : "",
                    }),
                    dispatch({
                        type: GET_EMPRESAPESSOA,
                        Name: (response.data && response.data.length > 0) ? JSON.parse(response.data)[1].name : "",
                        payload: (response.data && response.data.length > 0) ? JSON.parse(response.data)[1].data : "",
                    })
                ])
            )
            .catch(error => {
                return dispatch({
                    type: EMPRESAPESSOA_FORMULARIO_ERROR,
                    payload: error
                });
            });
    };
}

export function openNewDialog() {
    return {
        type: OPEN_NEW_EMPRESAPESSOA_FORMULARIO_DIALOG
    };
}

export function closeNewDialog() {
    return {
        type: CLOSE_NEW_EMPRESAPESSOA_FORMULARIO_DIALOG
    };
}

export function openEditDialog(data) {
    return {
        type: OPEN_EDIT_EMPRESAPESSOA_FORMULARIO_DIALOG,
        data
    };
}

export function closeEditDialog() {
    return {
        type: CLOSE_EDIT_EMPRESAPESSOA_FORMULARIO_DIALOG
    };
}

export function save(_AValue, _AParams, _AID) {
    return (dispatch) => {

        var AConditionsAND = [];
        var AConditionsOR = [];
        var AActions = [];
        var AAction = "INSERIR";

        if (_AValue.idpessoaformulario) {
            AAction = "ATUALIZAR";
            AConditionsAND = [{ "Campo": "idpessoaformulario", "Operador": "=", "Valor": _AValue.idpessoaformulario }];
            AActions = XAPPService.XappDoActionFactory(_AParams.empresa, AActions, "pessoaformulario", AAction, _AValue, "idpessoaformulario", AConditionsAND, AConditionsOR, 1, EmpresaPessoaFormularioUpdateState);
        }
        else {
            AActions = XAPPService.XappDoActionFactory(_AParams.empresa, AActions, "pessoaformulario", AAction, _AValue, "idpessoaformulario", AConditionsAND, AConditionsOR, 1, EmpresaPessoaFormularioAddState);
        }


        XAPPService.XappDoAction(AActions, _AParams, "DO")
            .then((response) => {
                if (response.warning) {
                    Promise.all([
                        dispatch({
                            type: EMPRESAPESSOA_FORMULARIO_WARNING,
                            payload: response.warning
                        })
                    ]).then(() => dispatch(list("SELECIONAR", _AParams, _AID)));
                }
                else if (response.info) {
                    Promise.all([
                        dispatch({
                            type: EMPRESAPESSOA_FORMULARIO_INFO,
                            payload: response.info,
                            id: response.ultimoidinserido
                        })
                    ]).then(() => dispatch(list("SELECIONAR", _AParams, _AID)));
                }
            }).catch(error => {
                return dispatch({
                    type: EMPRESAPESSOA_FORMULARIO_ERROR,
                    payload: error
                });
            });
    };
}

export function remove(_AValue, _AParams, _AID) {
    return (dispatch) => {

        var AConditionsAND = [{ "Campo": "idpessoaformulario", "Operador": "=", "Valor": _AValue.idpessoaformulario }];
        var AConditionsOR = [];
        var AActions = [];

        AActions = XAPPService.XappDoActionFactory(_AParams.empresa, AActions, "pessoaformulario", "EXCLUIR", "", "", AConditionsAND, AConditionsOR);

        XAPPService.XappDoAction(AActions, _AParams, "DO")
            .then(() =>
                Promise.all([
                    dispatch({
                        type: REMOVE_EMPRESAPESSOA_FORMULARIO
                    })
                ]).then(() => dispatch(list("SELECIONAR", _AParams, _AID)))
            )
            .catch(error => {
                return dispatch({
                    type: EMPRESAPESSOA_FORMULARIO_ERROR,
                    payload: error
                });
            });
    };
}

export function clearFormulario() {
    return (dispatch) => {
        Promise.all([
            dispatch({ type: GET_EMPRESAPESSOA_FORMULARIO, payload: null }),
            dispatch({ type: GET_EMPRESAPESSOA, payload: null }),
        ]);
    };
}

export function clearTemplate() {
    return {
        type: GET_EMPRESAPESSOA_FORMULARIO_TEMPLATE,
        payload: null
    };
}